import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Fade, Flex, } from "@chakra-ui/react";
import { MdError } from "react-icons/md";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { updateDsrTemplate } from '../actions/dsr-template-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import { MdAutoDelete } from "react-icons/md";
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


function ConfirmDeleteDsrTemplateModal({
  handleCloseModal,
  modalTransferPayload,
  updateDsrTemplate,
  updateDsrTemplateOutcome
}) {

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (updateDsrTemplateOutcome) {
      const { updateDsrTemplateStatus, sourceEvent } = updateDsrTemplateOutcome || {};
      if (updateDsrTemplateStatus === 'success' && sourceEvent === "delete-dsr-template") {
        setShowLoader(false);
        handleCloseModal()
      }
    }

  }, [updateDsrTemplateOutcome, handleCloseModal]);

  const handleConfirmDeleteTemplateButton = () => {

    const { dsrTemplateId } = modalTransferPayload || {}

    if (dsrTemplateId) {
      setShowLoader(true);

      updateDsrTemplate({
        sourceEvent: "delete-dsr-template",
        dsrTemplateId: dsrTemplateId,
        status: 'deleted'
      })
    }

  }


  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    const displayedDsrTitle = modalTransferPayload.dsrTitle ? <i>{modalTransferPayload.dsrTitle}</i> : "this template";

    if (!showLoader) {
      return (

        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500' direction='column' gap='1em'>
            <Box> Any Rooms that had been created with {displayedDsrTitle} will remain as they are, but this template will no longer be available for creating new ones.</Box>
            <Box> Go ahead?</Box>
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleConfirmDeleteTemplateButton()} label='Yes, delete template' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={showLoader ? <Fade in={true}>
        <Flex gap='1em' justify='flex-start' align='center'>
          <Box as={MdAutoDelete} color='brandDark.500' boxSize="1.6em" />
          <Box color='white'>Deleting the template...</Box>
        </Flex>

      </Fade> :
        <Flex gap='1em' justify='flex-start' align='center'>
          <Box as={MdError} color='brandPink.500' boxSize="1.6em" />
          <Box color='white'>You are about to delete this template</Box>
        </Flex>
      }
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    updateDsrTemplateOutcome: state.updateDsrTemplateOutcome.results.data,
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsrTemplate
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteDsrTemplateModal));
